export var GoiTypeId;
(function (GoiTypeId) {
    GoiTypeId["ImpactMonitor"] = "impactMonitor";
})(GoiTypeId || (GoiTypeId = {}));
